import { APP_VERSION, COMMIT_HASH } from '@/lib/version';

export function VersionDisplay() {
  return (
    <div className="fixed bottom-4 text-sm text-muted-foreground">
      Version {APP_VERSION} ({COMMIT_HASH})
    </div>
  );
}
